import AsyncEvent from '../core/AsyncEvent';
import SAMPLE from '../resources/sample';
function s4() {
	return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
}

function generateType3() {
	return ('w'+s4());
}

function generateType2() {
	return ('w'+s4()+s4()+s4()+s4());
}

function serializeData(data) {
	if (!angular.isObject(data)) {
		return((data == null) ? "" : data.toString());
	}

	var buffer = [];
	for (var name in data) {
		if (!data.hasOwnProperty(name)) {
			continue;
		}
		var value = data[name];
		buffer.push(encodeURIComponent(name) + "=" + encodeURIComponent((value == null) ? "" : value));
	}

	var source = buffer.join( "&" ).replace(/%20/g,"+");
	return(source);
}

function upload(file, token) {
	return new AsyncEvent((resolve, reject) => {
		var reader = new FileReader();
		var xhr = new window.XMLHttpRequest();
		xhr.open('POST', '/api/upload/', true);
		xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		reader.readAsDataURL(file);
		reader.onload = function(e){
			var params = {
				data: e.target.result,
				token: token,
				last: true,
			}
			xhr.send(serializeData(params));
		}

		xhr.onreadystatechange = function() { // Call a function when the state changes.
			if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
				resolve();
			}
		}
	})
}

class PresetService {
	constructor() {
		this.presetInfo = {};
	}

	static getPresetNames(msgbus) {
		var params = {};
		return msgbus.send('com.logpresso.core.msgbus.WallPlugin.getPresetNames', params, true);
	}

	static getPreset(msgbus, guid) {
		var params = { 'guid': guid };
		return msgbus.send('com.logpresso.core.msgbus.WallPlugin.getPreset', params, true);
	}

	static setPreset(msgbus, preset) {
		return msgbus.send('com.logpresso.core.msgbus.WallPlugin.setPreset', preset, true, true);
	}

	static removePreset(msgbus, guid) {
		return msgbus.send("com.logpresso.core.msgbus.WallPlugin.removePresets", { guids: [guid] });
	}
	
	static setPresetInfo(options) {
		this.presetInfo = options;
	}

	static getPresetInfo() {
		return this.presetInfo;
	}

	/**
	 * guid를 통해 대시보드를 저장합니다. token이 반환됩니다.
	 * @param {MessageBusService} msgbus 
	 * @param {string} guid 
	 * @return {string} token
	 */
	static exportWallPreset(msgbus, guid) {
		msgbus.send('com.logpresso.core.msgbus.WallPlugin.exportWallPreset', {
			guid: guid,
		}).onSuccess(resp => {
			var downloadUrl = location.protocol + '//' + location.hostname + ':' + location.port + '/downloader?token=' + resp.token;
			$('iframe#ifm-download').attr('src', downloadUrl);
		})
	}

	/**
	 * preset import를 준비합니다.
	 * @param {MessageBusService} msgbus
	 * @param {File} file
	 * @returns 
	 */
	static prepareImportPreset(msgbus, file) {
		return new AsyncEvent((resolve, reject) => {
			msgbus.send('com.logpresso.core.msgbus.FileUploadPlugin.prepareFileUpload', {
				handler_name: 'wall-preset',
				file_name: file.name,
				file_size: file.size,
			}, true, true).onSuccess(resp => {
				var token = resp.token;
				upload(file, token).onSuccess(resolve);
			})
		})
	}

	static grantPreset(msgbus, currentPreset, grants) {
		var target = Object.assign({}, currentPreset, grants);
		return new AsyncEvent((resolve, reject) => {
			PresetService.setPreset(msgbus, target)
			.onSuccess(resp => {
				resolve(target);
			});
		});
	}

	static getParentPresets(msgbus) {
		return new AsyncEvent((resolve, reject) => {
			PresetService.getPresetNames(msgbus)
			.onSuccess(resp => {
				resolve(resp.presets.filter(function(preset) {
					return !preset.parent;
				}));
			});
		});
	}

	static createParent(presetname, childguid, owner) {
		var parentguid = generateType2();
		var dockId = generateType2();

		var parentstate = {
			'layout': [{
				'rows': [{
					'cols': [{
						'droppable': false,
						'dragHandler': false,
						'guid': dockId,
						'w': 100
					}],
					'h': 100
				}],
				'w': 100,
				'droppable': false,
				'dragHandler': false
			}],
			'widgets': [{
				'data': {
					'tabs': [
						{
							'name': presetname,
							'guid': generateType2(),
							'is_active': true,
							'type': 'dockpanel',
							'contents': childguid
						}
					]
				},
				'guid': dockId,
				'name': presetname,
				'type': 'tabs'
			}],
			'style': {
				'widgetTitleFontSize': 14,
				'theme': 'white',
				'presetTitleFontSize': 20
			},
			'version': '2.0.1',
			'datasource': []
		};

		var presetobj = {
			'guid': parentguid,
			'name': presetname,
			'state': parentstate,
			'parent': null
			// 'owner': owner || 'gotoweb'
		};

		return presetobj;
	}

	static createChild(childguid, parentguid, childname = childguid) {
		return {
			'guid': childguid,
			'name': childname,
			'state': {
				'layout': [{
					'blank': true,
					'guid': undefined,
					'w': 100
				}],
				'widgets': [],
				'version': '2.0.1'
			},
			'parent': parentguid
		}
	}

	static createNew(msgbus, presetname, scope) {
		var childguid = generateType2();
		var parent = PresetService.createParent(presetname, childguid);
		var child = PresetService.createChild(childguid, parent.guid);
		return new AsyncEvent((resolve, reject) => {
			var self = this;
			PresetService.setPreset(msgbus, parent)
			.onSuccess(() => {
				PresetService.setPreset(msgbus, child)
				.onSuccess(() => {
					scope.$broadcast('PresetListController:updatePresetList');
					// scope.$emit('PresetListController:updatePresetList');

					resolve(parent);
				});
			});
		});
	}

	static createSample(msgbus, callback) {
		var childguid = generateType2();
		var parent = PresetService.createParent('Sample 2.0.0 Preset', childguid);
		var child = {
			'guid': childguid,
			'name': childguid,
			'state': SAMPLE,
			'parent': parent.guid
		}

		PresetService.setPreset(msgbus, parent)
		.onSuccess(() => {
			PresetService.setPreset(msgbus, child)
			.onSuccess(() => {
				callback(parent.guid);
			})
		});
	}

	static get(msgbus, guid) {
		return new AsyncEvent((resolve, reject) => {
			PresetService.getPresetNames(msgbus)
			.onSuccess(resp => {
				var p = resp.presets.find(preset => {
					return preset.guid === guid;
				});
				PresetService.getPreset(msgbus, p.guid)
				.onSuccess(resp2 => {
					resolve(resp2.preset);
				});
			});
		});
	}

	static clonePreset(msgbus, parent, newname, callback) {
		var parentguid = 'p' + generateType2();
		var ct = parent.state.widgets[0].data.tabs.map(tab => {
			return tab.contents
		});

		function clonePreset(preset) {
			var rx = /\"guid\":\"(\w+)\"/g;
			var replmap = {};
			var str = JSON.stringify(preset).replace(rx, function(a,b) {
				if(!(b in replmap)) {
					replmap[b] = 'w' + generateType2();
				}
				return '"guid": "' + replmap[b] + '"';
			});
			return JSON.parse(str);
		}

		var tabguids = [];

		function getTabPreset(arr) {
			if(arr.length == 0) {
				SaveParent();
			}
			else {
				PresetService.getPreset(msgbus, arr.pop()).onSuccess(resp => {

					if(!!LOGPRESSO.shared.renderPresetVersion) {
						resp.preset.state.version = LOGPRESSO.shared.renderPresetVersion;
					}

					var newguid = 'p' + generateType2();
					tabguids.push(newguid);
					var json = clonePreset(resp.preset.state);
					var obj = {
						'guid': newguid,
						'name': newguid,
						'state': json,
						'parent': parentguid
					}; // 자식 프리셋 복사한 오브젝트.

					PresetService.setPreset(msgbus, obj).onSuccess(() => {
						getTabPreset(arr)
					});
				});
			}
		}

		getTabPreset(ct);

		function cloneParentPreset(preset) {
			var rx = /\"contents\":\"(\w+)\"/g;
			var replmap = {};
			var str = JSON.stringify(preset).replace(rx, function(a,b) {
				if(!(b in replmap)) {
					replmap[b] = tabguids.pop();
				}
				return '"contents": "' + replmap[b] + '"';
			});
			return JSON.parse(str);
		}

		function SaveParent() {
			// tabguids.reverse();
			console.warn('SaveParent');

			var obj = {
				'guid': parentguid,
				'name': newname,
				'state': cloneParentPreset(parent.state)
			} // 부모프리

			PresetService.setPreset(msgbus, obj).onSuccess(function() {
				callback(parentguid);
			});
		}
	}

	static migrateFrom151(widgets) {
		console.log(widgets);

		var datasource = widgets.map(widget => {
			return {
				'name': widget.data.query,
				'query': widget.data.query,
				'interval': widget.interval,
				'guid': 'd' + generateType3()
			};
		});

		if(datasource.length > 0) {
			datasource = datasource.reduce((prev,curr) => {
				if(!prev) {
					return [curr];
				}

				if(!Array.isArray(prev)) {
					prev = [prev];
				}

				// console.log(JSON.stringify(prev))
				var existIdx;
				var exist = prev.some((item, i) => {
					if(item.query === curr.query) {
						existIdx = i;
						return true;
					}
					else {
						return false;
					}
				});

				if(exist) {
					prev[existIdx].interval = Math.min(prev[existIdx].interval, curr.interval);
					return prev;
				}
				else {
					return prev.concat([curr]);
				}
			});
		}

		if(!Array.isArray(datasource)) {
			datasource = [datasource];
		}

		var widgets = widgets.map(widget => {
			var found = datasource.find(src => {
				return src.query === widget.data.query;
			});
			// console.log(found.guid)
			delete widget.query;
			widget.data.source = {
				'guid': found.guid
			};
			return widget;
		});

		return {
			datasource,
			widgets,
			'version': '2.0.1'
		};

	}
}

export default PresetService;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/dashboard/PresetService.js